import { KsService } from '@siclop/kstone-vue'

export class SalaryGridService extends KsService {
  protected static mainUrl = '/salary-grids'
}
